const DEFAULT_USER_HOME = '/dashboard';

const firstNavigablePath = (items = []) => {
  for (const item of items) {
    if (item?.path) {
      return item.path;
    }

    const submenuPath = firstNavigablePath(item?.submenu || []);
    if (submenuPath) {
      return submenuPath;
    }
  }

  return null;
};

export const getStoredMenu = () => {
  try {
    const storedMenu = localStorage.getItem('menu');
    const parsedMenu = storedMenu ? JSON.parse(storedMenu) : [];
    return Array.isArray(parsedMenu) ? parsedMenu : [];
  } catch (error) {
    console.error('Error reading stored menu:', error);
    return [];
  }
};

export const getDefaultHomePath = (menuItems) => {
  return firstNavigablePath(menuItems || getStoredMenu()) || DEFAULT_USER_HOME;
};
